<template>
  <!-- Float -->
  <!-- Bottom -->
  <div style="position: fixed; right: 10px; bottom: 20px; z-index: 2">
    <div class="d-flex flex-column" style="gap: 4px">
      <!-- สำหรับ Connect Line -->
      <v-btn
        v-if="isShowConnectWithLine"
        rounded
        small
        style="
          height: 32px;
          padding: 0px 8px 0px 4px;
          box-shadow: 8px 4px 16px -4px #01b90280;
        "
        @click="onClickMenuLine"
      >
        <div class="d-flex align-center" style="gap: 8px">
          <div
            style="
              width: 24px;
              height: 24px;
              display: flex;
              align-items: center;
              justify-content: center;
              background-color: #01b902;
              border-radius: 50%;
            "
          >
            <v-img
              :src="require('@/assets/social/line-circle.svg')"
              style="width: 20px; height: 20px; pointer-events: none"
            ></v-img>
          </div>
          <div class="text-none">
            {{ $t("microsite.textConnectWithLine") }}
          </div>
          <div style="margin-bottom: 1px">
            <v-icon small color="#01b902"> mdi-chevron-right </v-icon>
          </div>
        </div>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { connectLineMicrositeUser } from "../../../../config/line-service-login";

export default {
  inject: ["isAppLoading"],
  props: {
    pageName: {
      default: "",
    },
    campaign: {
      default: () => ({}),
    },
  },
  data: () => ({
    isShowConnectWithLine: false,
  }),
  methods: {
    async onClickMenuLine() {
      this.isAppLoading(true);
      const res = await connectLineMicrositeUser(this.$route.params.slug);
      if (!res) {
        this.isAppLoading(false);
      }
    },
  },
  computed: {
    ...mapState("microsite", ["user"]),
    ...mapState("defaultSystem", ["site"]),
  },
  watch: {
    campaign: {
      handler() {
        if (["MicrositeMenu"].includes(this.pageName)) {
          this.isShowConnectWithLine = this.campaign.is_use_connect_line;
          if (this.user.line_id) {
            this.isShowConnectWithLine = false;
          }
        }
      },
    },
  },
};
</script>

<style scoped>
</style>